import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import ReactGA from 'react-ga4'

interface IAccordionLayout {
  title: string
  index: number
  expanded: number | false
  handleExpandedChange: (panel: number) => void
  children: React.ReactNode
}

const AccordionLayout = ({ title, index, children, expanded, handleExpandedChange }: IAccordionLayout) => {
  const handleClick = () => {
    ReactGA.gtag('event', 'click_accordion')
  }
  return (
    <Accordion
      slotProps={{ transition: { unmountOnExit: true } }}
      expanded={expanded === index}
      onChange={(_, expanded) => {
        if (expanded) {
          handleClick()
        }
        handleExpandedChange(index)
      }}
      sx={{
        borderRadius: 0,
        border: '1px solid #d3d3d324',
        '&:first-of-type': { borderTopLeftRadius: 5, borderTopRightRadius: 5 },
        '&:last-of-type': { borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />} sx={{ padding: 2 }}>
        {title}
      </AccordionSummary>
      <AccordionDetails sx={{ background: '#1d1d1d', paddingBottom: 4, paddingTop: 2, margin: 0 }}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionLayout
